import styled from 'styled-components';
import { margin, variant } from 'styled-system';
import { Text } from '../Text/Text';
import { Theme } from '../../../theme/theme';
import { PaddingProps } from '../../../theme/styledProps';
import { RawButton } from '../Button/Button.styles';
import { Icon } from '../Icon/Icon';

export const HelperText = styled(Text)``;
export const StyledIcon = styled(Icon)``;

export type SizeVariant = 'small' | 'medium';

interface Props {
  theme: Theme;
  sizeVariant: SizeVariant;
  disabled?: boolean;
}

export const VisualPickerButtonWrapper = styled(RawButton)<Props>(
  ({ theme, disabled }) => ({
    fontFamily: theme.fontFamily,
    fontSize: theme.fontSizes.body,
    lineHeight: theme.lineHeights.body,
    fontWeight: theme.fontWeights['500'],
    borderRadius: theme.radii.medium,
    border: `1px solid ${theme.colors.neutral['300']}`,
    color: disabled ? theme.colors.neutral['500'] : theme.colors.neutral['700'],
    boxShadow: theme.shadows['200'],
    background: disabled ? theme.colors.neutral['100'] : theme.colors.bg,
    textAlign: 'left',
    pointerEvents: disabled ? 'none' : 'initial',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    transition: `box-shadow ${theme.transitions.normal}, border ${theme.transitions.normal}, background ${theme.transitions.normal}, color ${theme.transitions.normal}`,

    [StyledIcon]: {
      marginRight: '16px !important',
      color: theme.colors.neutral['500'],
    },

    [HelperText]: {
      color: theme.colors.neutral['500'],
      fontSize: theme.fontSizes.small,
      fontWeight: theme.fontWeights['400'],
      lineHeight: theme.lineHeights.small,
      marginTop: 4,
    },

    '@media (hover: hover)': {
      '&:not(.disabled):hover': {
        boxShadow: theme.shadows['400'],
        borderColor: theme.colors.neutral['400'],
      },

      '&:not(.disabled)[aria-pressed=true]:hover': {
        boxShadow: theme.shadows['400'],
        borderColor: theme.colors.primary['400'],
        background: theme.colors.primary['100'],
      },

      '&[data-focus-visible-added]:not(.disabled):focus': {
        outline: 'none',
        borderColor: theme.colors.primary['500'],
        boxShadow: `0px 0px 0px 2px ${theme.colors.primary['300']}`,
      },
    },

    '&:not(.disabled):active, &[aria-pressed=true]': {
      boxShadow: theme.shadows['200'],
      background: theme.colors.primary['100'],
      borderColor: theme.colors.primary['300'],
      color: theme.colors.primary['600'],

      [HelperText]: {
        color: theme.colors.primary['600'],
      },

      [StyledIcon]: {
        color: theme.colors.primary['500'],
      },

      '&:not(.disabled):focus': {
        background: theme.colors.primary['100'],
      },
    },

    '@media print': {
      boxShadow: 'none !important',
      transition: 'none !important',
      pageBreakInside: 'avoid',
      border: `1px solid ${theme.colors.neutral['200']} !important`,
    },
  }),

  variant<PaddingProps, SizeVariant>({
    prop: 'sizeVariant',
    variants: {
      small: {
        px: '16',
        py: 14,
      },

      medium: {
        px: '16',
        py: 21,
      },
    },
  }),

  margin,
);
